/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";


import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// CSS

import cssStyles from "./mercadoPagoPaymentSettings.module.css";

//IMPORTS
import { updatePayment } from "../../../reducers/paymentSlice";
import paymentsConstants from "../../../constants/payments.constants";
import { Notification } from "../../../containers/notification";
import { selectUser } from "../../../reducers/userSlice";
import mongoose from "mongoose";
import { loadingOff, loadingOn, selectLoadingUI } from "../../../reducers/uiSlice";
import { selectCompany, getCompany } from "../../../reducers/companySlice";
import { useChangeRecord } from "../../../utils/hooks/useChangeRecord";
import companyService from "../../../utils/services/company";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../reducers/depositSlice";
import jwt from "jsonwebtoken";
import config from "../../../utils/config";
import InputComponent from "../../inputs";
import { useNavigate } from "react-router-dom";
import { selectSubsidiaries } from "../../../reducers/subsidiarySlice";
import { Tab, Tabs } from "@material-ui/core";
import ChangeLogs from "../../changeLogs/changeLogs";
import { useMemo } from "react";
import { CalendarIcon, CheckCircleGreenIcon, CloseCircleGrayIcon, CreditCardIcon, DollarSignIcon, MoneyBillIcon } from "../../../assets/icons/svgIcons";
const defaultData = (company) => ({
  name: paymentsConstants.TYPES.Mercadopago,
  factor: 1,
  duration: 60,
  startTime: "01:00",
  endTime: "23:59",
  details: [{ apiKey: "", apiSecret: "", useForm: false }],
  useSandbox: false,
  _id: new mongoose.Types.ObjectId().toHexString(),
  IdCompany: company._id,
  subsidiaryId: "",
});
function MercadopagoSettingsComponent(props) {
  const company = useSelector(selectCompany);
  const [updated, setUpdated] = useState(false);
  const [useMercadopago, setUseMercadopago] = useState(false);
  const subsidiaries = useSelector(selectSubsidiaries);
  const { enqueueSnackbar } = useSnackbar();
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [subsidiaryId, setSubsidiaryId] = useState(subsidiaries[0]?._id ?? "");
  const { recordChange } = useChangeRecord();
  const [mercadoLibreCredentials, setMercadoLibreCredentials] = useState([])
  const loading = useSelector(selectLoadingUI)
  const handleCancel = () => {
    // Reload company to reset changes
    getCompany(company._id, dispatch);
    setUpdated(false);
  };

  const handleSave = async () => {
    try {
      dispatch(loadingOn());

      const savePromises = mercadoLibreCredentials.map(async (credential) => {
        const detail = credential.details[0];

        const ensureJwt = (val) => {
          if (!val) return "";
          try {
            jwt.verify(val, config.jwtSecret);
            return val;
          } catch (e) {
            return jwt.sign(val, config.jwtSecret);
          }
        };

        const updatedPayment = {
          ...credential,
          IdCompany: company._id,
          details: [{
            ...detail,
            apiKey: ensureJwt(detail.apiKey),
            apiSecret: ensureJwt(detail.apiSecret),
            useForm: detail.useForm
          }]
        };
        return updatePayment(updatedPayment, user.token);
      });

      await Promise.all(savePromises);

      await handleCompanySave();
      setUpdated(false);
      enqueueSnackbar(
        Notification({
          text: "Métodos de pagos actualizados",
          variant: "success",
          withDetails: false,
        })
      );
    } catch (err) {
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar métodos de pago",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };
  const handleCredentialChange = (field, value, subsidiaryId) => {



    const currentCredential = mercadoLibreCredentials.find(
      (item) => company?.useSubsidiaryPayment ? item.subsidiaryId === subsidiaryId : !item.subsidiaryId
    )
    // Track changes
    let oldValue = "";

    if (currentCredential?.details?.[0]?.[field] && field !== "useForm") {
      try {
        oldValue = jwt.verify(currentCredential.details[0][field], config.jwtSecret);
      } catch (e) {
        oldValue = currentCredential.details[0][field];
      }
    }

    trackFieldChange(
      field,
      field === "useForm" ? !oldValue ? "Activo" : "Inactivo" : oldValue,
      field === "useForm" ? value ? "Activo" : "Inactivo" : value,
      subsidiaryId
    );

    setMercadoLibreCredentials((prev) => {
      const exists = company?.useSubsidiaryPayment ? prev.find((item) => item.subsidiaryId === subsidiaryId) : prev.find((item) => !item.subsidiaryId);
      if (exists) {
        return prev.map((item) => {
          if (company?.useSubsidiaryPayment ? item.subsidiaryId === subsidiaryId : !item.subsidiaryId) {
            return {
              ...item,
              details: [
                {
                  ...item.details[0],
                  [field]: value,
                },
              ],
            };
          }
          return item;
        });
      }
      // If it doesn't exist, we might need to create it, but usually it should exist if we are editing.
      // Assuming it exists for now based on initialization logic.
      return prev;
    });
    setUpdated(true);
  };

  const handleUseMercadopagoChange = (checked) => {
    trackFieldChange(
      "useMercadopago",
      company?.UsePayments?.useMercadopago ? "Activo" : "Inactivo",
      checked ? "Activo" : "Inactivo",
    );
    setUseMercadopago(checked);
    setUpdated(true);
  };

  const handleCompanySave = async () => {
    try {
      await companyService.updateCompany(
        company._id,
        {
          _id: company._id,
          UsePayments: {
            ...company.UsePayments,
            useMercadopago,
          },
        },
        user.token
      );

      await getCompany(company._id, dispatch);
      enqueueSnackbar(
        Notification({
          text: "Datos de la tienda actualizados",
          variant: "success",
          withDetails: false,
        })
      );
      setUpdated(false);
      await recordChange({
        module: "Métodos de pago",
        submodule: "MercadoPago",
        changes: changes,
      });
    } catch (err) {
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar datos de la tienda",
          variant: "error",
          withDetails: false,
        })
      );
    }
  };

  const trackFieldChange = (field, oldValue, newValue, subsidiaryId) => {
    if (oldValue === newValue) return; // no change

    const logs = [...changes];

    const existing = logs.find(
      (l) => l.field === field && l?.subsidiaryId === subsidiaryId
    );
    const selectedSubsidiary = subsidiaries?.find(
      (f) => f?._id === subsidiaryId
    );

    const newLog = {
      field,
      text: `Cambió el campo ${field} para ${selectedSubsidiary ? selectedSubsidiary?.Name : "todas las sucursales"}`,
      oldValue: existing ? existing.oldValue : oldValue,
      newValue,
      date: new Date().toISOString(),
      subsidiaryId,
    };

    if (existing) {
      const index = logs.findIndex((l) => l.field === field);
      logs[index] = newLog;
    } else {
      logs.push(newLog);
    }

    dispatch(setChanges(logs));
  };

  const handleClose = () => {
    navigate(-1);
  };


  // Removed the useEffect that was resetting local state on payment change, 
  // as we now use mercadoLibreCredentials directly.

  const credentials = useMemo(() => {
    if (!mercadoLibreCredentials?.length) return {};
    const filtered = mercadoLibreCredentials.find((item) =>
      company?.useSubsidiaryPayment ? item.subsidiaryId === subsidiaryId : !item.subsidiaryId
    );


    if (!filtered) {
      return {};
    }

    const originalDetails = filtered?.details?.[0];
    if (!originalDetails) {
      return filtered;
    }

    // Attempt to verify JWTs, but fallback to raw value if verification fails (e.g. user is typing)
    let apiKey = originalDetails.apiKey;
    let apiSecret = originalDetails.apiSecret;

    try {
      apiKey = jwt.verify(originalDetails.apiKey, config.jwtSecret);
    } catch (e) {
      // ignore, use raw
    }

    try {
      apiSecret = jwt.verify(originalDetails.apiSecret, config.jwtSecret);
    } catch (e) {
      // ignore, use raw
    }

    const verifiedDetails = {
      apiKey,
      apiSecret
    };
    return {
      ...filtered,
      details: [{ ...originalDetails, ...verifiedDetails }]
    };
  }, [mercadoLibreCredentials, subsidiaryId, company?.useSubsidiaryPayment]);


  useEffect(() => {
    if (subsidiaries?.length) setSubsidiaryId(subsidiaries?.[0]?._id);
  }, [subsidiaries.length]);



  useEffect(() => {
    if (!company || !subsidiaries?.length) return;
    const { Payments, UsePayments, useSubsidiaryPayment } = company;
    setUseMercadopago(!!UsePayments?.useMercadopago);

    let found = [];
    if (Payments?.length) {
      found = Payments.filter((item) =>
        !useSubsidiaryPayment
          ? item.name === paymentsConstants.TYPES.Mercadopago &&
          !item.subsidiaryId
          : item.name === paymentsConstants.TYPES.Mercadopago &&
          item.subsidiaryId
      );
    }

    if (found?.length > 0) {
      if (useSubsidiaryPayment) {
        const completeCredentials = [...found];
        const foundSubsidiaryIds = found.map((item) => item.subsidiaryId);

        subsidiaries?.forEach((sub) => {
          if (!foundSubsidiaryIds.includes(sub._id)) {
            completeCredentials.push({
              ...defaultData(company),
              subsidiaryId: sub._id,
            });
          }
        });
        setMercadoLibreCredentials(completeCredentials);
      } else {
        setMercadoLibreCredentials(found);
      }
    } else {
      if (useSubsidiaryPayment) {
        setMercadoLibreCredentials(
          subsidiaries?.map((item) => ({
            ...defaultData(company),
            subsidiaryId: item._id,
          })) || []
        );
      } else {
        setMercadoLibreCredentials([defaultData(company)]);
      }
    }
  }, [company, subsidiaries]);
  return (
    <div className={cssStyles.parentContainer}>
      <div className={cssStyles.btnBackContainer}>
        <button
          className={cssStyles.backButton}
          onClick={() => handleClose()}
        >
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>

        <ChangeLogs
          {...{
            module: "Métodos de pago",
            subtitle: (
              <span>
                Historial de modfificación de credenciales de{" "}
                <strong>Mercado Libre</strong>
              </span>
            ),
          }}
        />
      </div>

      <div className={cssStyles.infoContainer}>
        <div className={cssStyles.titleLogoContainer}>
          <div className={cssStyles.containerLogo}>
            <img
              src="https://s3.amazonaws.com/lumarketo.cl/mercadopago-svg-payments.svg"
              alt="mercadopago"
            />
          </div>{" "}

          {!useMercadopago ? (
            <div className={cssStyles.containerLogoInactive}>
              <CloseCircleGrayIcon />
              <span>Inactivo</span>
            </div>
          ) : (
            <div
              className={cssStyles.containerLogoActive}
              style={{ fontWeight: 700 }}
            >
              <CheckCircleGreenIcon />
              <span>Activo</span>
            </div>
          )}
        </div>

        {PaymentInfo()}

        {company?.useSubsidiaryPayment && (
          <Tabs
            value={subsidiaryId}
            indicatorColor="primary"
            textColor="primary"
            onChange={(event, newValue) => setSubsidiaryId(newValue)}
            aria-label="disabled tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subsidiaries?.map((item) => (
              <Tab label={item.Name} value={item._id} />
            ))}
          </Tabs>
        )}


        <div className={cssStyles.configSettingsContainer}>
          <div className={cssStyles.inputContainer}>
            <label className={cssStyles.labelInput}>Public Key</label>

            <InputComponent
              placeholder="12345678"
              type="text"
              validation={credentials?.details?.[0]?.apiKey === ""}
              helperText={credentials?.details?.[0]?.apiKey === "" ? "Recuerde indicar la public key" : ""}
              value={credentials?.details?.[0]?.apiKey}
              handler={(e) => {
                handleCredentialChange("apiKey", e.target.value, subsidiaryId);
              }}
              key={subsidiaryId}
              disabled={loading}
            />
          </div>
          <div className={cssStyles.inputContainer}>
            <label className={cssStyles.labelInput}>Access Token</label>

            <InputComponent
              placeholder="12345678"
              type="text"
              validation={credentials?.details?.[0]?.apiSecret === ""}
              helperText={
                credentials?.details?.[0]?.apiSecret === "" ? "Recuerde indicar el access token" : ""
              }
              value={credentials?.details?.[0]?.apiSecret}
              handler={(e) => {
                handleCredentialChange("apiSecret", e.target.value, subsidiaryId);
              }}
              key={subsidiaryId}
              disabled={loading}
            />
          </div>
          <div className={cssStyles.inputContainerCheckbox}>

            <input
              type="checkbox"
              className={cssStyles.inputElementCheckbox}
              checked={credentials?.details?.[0]?.useForm}
              onChange={(e) =>
                handleCredentialChange("useForm", e.target.checked, subsidiaryId)
              }
              value={credentials?.details?.[0]?.useForm}
              id={"useForm"}
              key={subsidiaryId}
              disabled={loading}
            />
            <label className={cssStyles.labelInput}>
              Activar uso de formulario
            </label>
          </div>
          <div
            className={cssStyles.divider}
          />

          <div className={cssStyles.inputContainerCheckbox}>
            <input
              type="checkbox"
              checked={!!useMercadopago}
              onChange={(e) =>
                handleUseMercadopagoChange(e.target.checked, subsidiaryId)
              }
              className={cssStyles.inputElementCheckbox}
              value={!!useMercadopago}
              id={"useMercadopago"}
              key={subsidiaryId}
              disabled={loading}
            />
            <label className={cssStyles.labelInput}>
              Activar uso de mercado pago
            </label>
          </div>
        </div>


        <div className={cssStyles.buttonsContainer}>
          <button
            className={cssStyles.cancelButton}
            disabled={!updated}
            onClick={() => handleCancel()}
          >
            Cancelar
          </button>
          <button
            className={cssStyles.confirmButton}
            disabled={!updated || loading}
            onClick={() => handleSave()}
          >
            Actualizar credenciales
          </button>
        </div>

      </div>
      <div className={cssStyles.howtouse_card}>
        <h3 className={cssStyles.howtouse_title}>
          Guía rápida de activación de mercado pago en 4 pasos.
        </h3>

        <p className={cssStyles.howtouse_paragraph}>
          Para activar esta pasarela de pago, debes tener una cuenta activa en mercado pago. En caso de no tener una,
          puedes registrarte de forma gratuita en el siguiente enlace.
        </p>



        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.mercadopago.cl/"
        >
          {" "}
          <button className={cssStyles.howtouse_button} >
            <span className={cssStyles.howtouse_buttonText}>Crear cuenta en MercadoPago</span>
            <img
              className="buttonLogoMp"
              src="https://s3.amazonaws.com/lumarketo.cl/mercadopago-svg-payments.svg"
              alt="logoMercaPago"
            />
          </button>
        </a>

        <div className={cssStyles.howtouse_stepsSection}>
          <div className={cssStyles.howtouse_stepsIntro}>
            <p className={cssStyles.howtouse_stepsSubtitle}>Ya tengo una cuenta</p>
            <p className={cssStyles.howtouse_stepsParagraph}>
              Una vez que crearas una cuenta en mercado pago, debes seguir los siguientes pasos dentro de su página para
              activar esta información:
            </p>
          </div>

          <ol className={cssStyles.howtouse_stepsList}>
            <li>
              Debes ubicarte en el menú y hacer clic en la sección "tu negocio", para posteriormente seleccionar la opción de
              "configuraciones".
            </li>
            <li>
              Esto te redirigirá a una sección que debes llenar con los datos de tu negocio, y una vez completado, debes
              hacer clic en la sección de "credenciales" que estará a la derecha.
            </li>
            <li>
              La plataforma mostrará dos opciones, las credenciales de producción y las credenciales de prueba.
              Selecciona las "credenciales de producción"
            </li>
            <li>
              Copia la "public key" y la "access token". Para posteriormente pegarlas en la sección de mismo nombre aquí en
              la plataforma completas.
            </li>
          </ol>
        </div>

        <a
          target="_blank"
          rel="noreferrer"
          href="https://lumarketo.com/mercadopago"
        >
          Para una guía mas completa ir a ¿Cómo configurar mercado pago?
        </a>
      </div>


    </div>

  );
}






// Fragmento JSX solicitado
const PaymentInfo = () => (
  <>
    {/* Sección de Métodos de Pago */}
    <div className={cssStyles.howtouse_section}>
      <p className={cssStyles.howtouse_paymentTitle}>Permite a tus clientes pagar con</p>
      <div className={cssStyles.howtouse_paymentGrid}>
        <div className={cssStyles.howtouse_paymentItem}>
          <DollarSignIcon color="#99A1AF" width={24} height={24} strokeWidth={2} />
          <span className={cssStyles.howtouse_paymentText}>Efectivo</span>
        </div>
        <div className={cssStyles.howtouse_paymentItem}>
          <MoneyBillIcon color="#99A1AF" width={24} height={24} strokeWidth={2} />
          <span className={cssStyles.howtouse_paymentText}>Dinero de MercadoPago</span>
        </div>
        <div className={cssStyles.howtouse_paymentItem}>
          <CreditCardIcon color="#99A1AF" width={24} height={24} strokeWidth={2} />
          <span className={cssStyles.howtouse_paymentText}>Tarjeta de Débito/Crédito</span>
        </div>
        <div className={cssStyles.howtouse_paymentItem}>
          <CalendarIcon color="#99A1AF" width={24} height={24} strokeWidth={2} />
          <span className={cssStyles.howtouse_paymentText}>Cuotas sin interés</span>
        </div>
      </div>
    </div>

    {/* Fee Information */}
    <div className={cssStyles.howtouse_section}>
      <p className={cssStyles.howtouse_feeTitle}>
        MercadoPago te ofrece las siguientes opciones para retirar el dinero acumulado
      </p>
      <div className={cssStyles.howtouse_feeGrid}>
        {/* Opción 1: 14 días */}
        <div>
          <p className={cssStyles.howtouse_feeLabel}>Pagas</p>
          <p className={cssStyles.howtouse_feeValueContainer}>
            <span className={cssStyles.howtouse_feeRate}>2.45%</span>
            <span className={cssStyles.howtouse_feeIva}> + IVA</span>
          </p>
        </div>
        <div>
          <p className={cssStyles.howtouse_feeLabel}>Retiras tu dinero en</p>
          <p className={cssStyles.howtouse_feeDays}>14 días</p>
        </div>

        {/* Opción 2: De inmediato */}
        <div>
          <p className={cssStyles.howtouse_feeLabel}>Pagas</p>
          <p className={cssStyles.howtouse_feeValueContainer}>
            <span className={cssStyles.howtouse_feeRate}>2.95%</span>
            <span className={cssStyles.howtouse_feeIva}> + IVA</span>
          </p>
        </div>
        <div>
          <p className={cssStyles.howtouse_feeLabel}>Retiras tu dinero en</p>
          <p className={cssStyles.howtouse_feeImmediate}>De inmediato</p>
        </div>
      </div>
    </div>

    <a
      target="_blank"
      rel="noreferrer"
      href="https://lumarketo.com/mercadopago"
      className={cssStyles.howtouse_helpLink}

    >
      <span className="mercadopagoFotterButtonBlank">
        Ver: ¿ Cómo configurar MercadoPago ?
      </span>
    </a>
  </>
);







export default MercadopagoSettingsComponent;
